import ajax from "@/lib/ajax";

/**
 * 读取住汇总表信息
 * @param payload 查询条件
 */
export async function GetReportSummaryList(payload: string) {
    let res = await ajax.get(`/api/services/app/PDSummary/GetReportSummaryList?selectTime=` + payload );
    return res.data.result;
}

/**
 * 读取住chart数据
 * @param payload 查询条件
 */
export async function GetSummaryChartList(payload: any) {
    let res = await ajax.get(`/api/services/app/PDSummary/GetSummaryChartList?chartType=`+payload.chartType +`&selectTime=`+ payload.time);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdQualityControlManage/pdSummary/index.ts